import {PlayerColor} from '../PlayerState'
import {TileEdgeDirection} from './TileEdgeState'

export enum TileEdgePortType {
    Port = 1,
    PortLumber = 2,
    PortBrick = 3,
    PortWool = 4,
    PortGrain = 5,
    PortOre = 6,
}

export interface PortEdgeState {
    readonly x: number
    readonly y: number
    readonly z: TileEdgeDirection
    readonly type: TileEdgePortType
    owner?: Exclude<PlayerColor, PlayerColor.None>
}
